import React, { Component } from "react";

import "../../../css/Loader.css";

export default class Loader extends Component {
  render() {
    return (
      <div className="loader-space">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}
